import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { PasswordModule } from "primeng/password";
import { LoginRequest } from "src/app/models/login-request.model";
import { LoginService } from "src/app/services/login.service";

@Component({
    selector: "login-page",
    templateUrl: "./login.page.html",
    styleUrls: ["./login.page.scss"],
    standalone: true,
    imports: [ButtonModule, CardModule, CommonModule, FormsModule, InputTextModule, PasswordModule],
    providers: [LoginService],
})
export class LoginPage {
    protected userName: string = "";
    protected password: string = "";
    protected errorMessage: string = "";
    protected showError: boolean = false;

    constructor(private router: Router, private loginService: LoginService) {}

    login() {
        this.loginService.login(<LoginRequest>{userName: this.userName, password: this.password}).subscribe((res) => {
            this.router.navigate(['/home']);
        }, (err) => {
            this.errorMessage = "Ongeldige inloggegevens. Probeer het opnieuw.";
            this.showError = true;
        });
    }
}